import { render, staticRenderFns } from "./transfer_log.vue?vue&type=template&id=2c5710cb&scoped=true&"
import script from "./transfer_log.vue?vue&type=script&lang=js&"
export * from "./transfer_log.vue?vue&type=script&lang=js&"
import style0 from "./transfer_log.vue?vue&type=style&index=0&id=2c5710cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5710cb",
  null
  
)

export default component.exports